import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
  SelectInsumosItem,
  dineroDisabledMask
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
  texto,
  identificador,
  numero,
  moneda,
  totalizar,
  construirHojaTabla,
  descargarLibro,
  limpiarNombreArchivo,
} from "../../../../Components/ExcelTablaReporte";
import moment from "moment";
import "moment/locale/es";
// import { ResponsiveSwarmPlot } from "@nivo/swarmplot";
import reporteEntradasSalidasPdf from "../../../../Pdf/reporteEntradasSalidasPdf";
import dayjs from "dayjs";



moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteEntradasSalidas extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInventario: [],
    dataGrafico: [],
    valorMaximoCirculo: 0,
    mostrarApartados: false,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteEntradasSalidas({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  consultarReporteEntradasSalidas(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteEntradasSalidas",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          // this.crearGrafico(
          //   res.data.inventario,
          // );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInventario: res.data.movimientos,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  /** Los movimientos que se estan viendo: el archivo tiene que decir lo mismo que la tabla. */
  movimientosVisibles() {
    if (this.state.mostrarApartados) return this.state.todasInventario;
    return this.state.todasInventario.filter((value) => !value.esMovimientoApartado);
  }

  /** El periodo consultado y los filtros, para la banda del Excel. */
  descripcionFiltros() {
    const rango = this.state.dataReporte?.rango;
    const partes = [];
    if (rango?.startDate && rango?.endDate) {
      partes.push(
        `Del ${moment(rango.startDate).format("DD/MM/YYYY")} al ${moment(
          rango.endDate
        ).format("DD/MM/YYYY")}`
      );
    }
    const proyectos = this.state.dataReporte?.filtros?.proyectos || [];
    if (proyectos.length) partes.push(`${proyectos.length} proyecto(s)`);
    if (this.state.mostrarApartados) partes.push("Incluye movimientos de apartado");
    return partes.join(" - ");
  }

  /** El sufijo del nombre de archivo: el periodo, no la fecha de descarga. */
  sufijoPeriodo() {
    const rango = this.state.dataReporte?.rango;
    if (!rango?.startDate || !rango?.endDate) return moment().format("YYYY-MM-DD");
    return `${moment(rango.startDate).format("YYYY-MM-DD")}_a_${moment(
      rango.endDate
    ).format("YYYY-MM-DD")}`;
  }

  construirTabla() {
    const movimientos = this.movimientosVisibles();
    const columnas = [
      { titulo: "Fecha", tipo: "texto", ancho: 18 },
      { titulo: "E / S", tipo: "texto", ancho: 10 },
      { titulo: "Codigo", tipo: "identificador", ancho: 16 },
      { titulo: "Clave", tipo: "identificador", ancho: 18 },
      { titulo: "Descripcion", tipo: "texto", ancho: 42 },
      { titulo: "Familia", tipo: "texto", ancho: 20 },
      { titulo: "Marca", tipo: "texto", ancho: 18 },
      { titulo: "Unidad", tipo: "texto", ancho: 12 },
      { titulo: "Cantidad", tipo: "numero", ancho: 12 },
      { titulo: "Costo Unitario", tipo: "moneda", ancho: 16 },
      { titulo: "Importe", tipo: "moneda", ancho: 16 },
      { titulo: "Proveedor", tipo: "texto", ancho: 34 },
      { titulo: "Documento", tipo: "texto", ancho: 22 },
      { titulo: "Concepto", tipo: "texto", ancho: 38 },
      { titulo: "Responsable", tipo: "texto", ancho: 28 },
      { titulo: "Apartado", tipo: "texto", ancho: 10 },
    ];

    const filas = movimientos.map((value) => [
      texto(value.createdAt ? dayjs(value.createdAt).format("DD/MM/YYYY HH:mm") : ""),
      texto(value.salida ? "Salida" : "Entrada"),
      identificador(value.codigoInsumo),
      identificador(value.claveInsumo),
      texto(value.descripcionInsumo),
      texto(value.nombreFamilia),
      texto(value.nombreMarca),
      texto(value.nombreUnidad),
      numero(value.cantidad),
      // Vacios en lo que no es una recepcion de compra: un ajuste manual o un
      // traspaso no tienen costo de compra ni proveedor.
      moneda(value.costo),
      moneda(value.importe),
      texto(value.proveedorNombre),
      texto(value.documentoCompra),
      texto(value.concepto),
      texto(value.nombreUsuario),
      texto(value.esMovimientoApartado ? "Si" : "No"),
    ]);

    return { columnas, filas, totales: totalizar(columnas, filas) };
  }

  descargarExcel() {
    descargarLibro(
      [
        {
          nombre: "Entradas y Salidas",
          hoja: construirHojaTabla(this.construirTabla(), {
            titulo: "Reporte de Entradas y Salidas",
            empresaNombre: this.props.empresa,
            descripcionFiltros: this.descripcionFiltros(),
          }),
        },
      ],
      limpiarNombreArchivo(`Reporte_Entradas_Salidas_${this.sufijoPeriodo()}`)
    );
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteEntradasSalidasPdf(this.state.dataReporte))
      .download(
        limpiarNombreArchivo(`Reporte_Entradas_Salidas_${this.sufijoPeriodo()}`)
      );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (v) => (v ? dayjs(v).format("DD/MM/YYYY HH:mm") : "—"),
        sorter: (a, b) => (a.createdAt || "").localeCompare(b.createdAt || ""),
        buscar: "createdAt",
        ellipsis: true,
      },
      {
        title: "E / S",
        dataIndex: "salida",
        key: "salida",
        render: (text, record) => (
          <span>{record.salida ? "Salida" : "Entrada"}</span>
        ),
        buscar: "salida",
        ellipsis: true,
      },

      {
        title: "Clave",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        sorter: (a, b) => (a.claveInsumo || "").localeCompare(b.claveInsumo || ""),
        buscar: "claveInsumo",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        sorter: (a, b) => (a.descripcionInsumo || "").localeCompare(b.descripcionInsumo || ""),
        buscar: "descripcionInsumo",
        ellipsis: true,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        sorter: (a, b) => (a.nombreFamilia || "").localeCompare(b.nombreFamilia || ""),
        buscar: "nombreFamilia",
        ellipsis: true,
      },
      {
        title: "Marca",
        dataIndex: "nombreMarca",
        key: "nombreMarca",
        sorter: (a, b) => (a.nombreMarca || "").localeCompare(b.nombreMarca || ""),
        buscar: "nombreMarca",
        ellipsis: true,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        sorter: (a, b) => (a.nombreUnidad || "").localeCompare(b.nombreUnidad || ""),
        buscar: "nombreUnidad",
        ellipsis: true,
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => (a.cantidad || 0) - (b.cantidad || 0),
        buscar: "cantidad",
        ellipsis: true,
      },
      {
        // Solo las recepciones de compra traen costo; en un ajuste o un traspaso
        // la celda queda vacia a proposito.
        title: "Costo Unitario",
        dataIndex: "costo",
        key: "costo",
        render: (text) => (text ? dineroDisabledMask(text) : "-"),
        sorter: (a, b) => (a.costo || 0) - (b.costo || 0),
        buscar: "costo",
        ellipsis: true,
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
        sorter: (a, b) => (a.proveedorNombre || "").localeCompare(b.proveedorNombre || ""),
        buscar: "proveedorNombre",
        ellipsis: true,
      },
      {
        title: "Documento",
        dataIndex: "documentoCompra",
        key: "documentoCompra",
        sorter: (a, b) => (a.documentoCompra || "").localeCompare(b.documentoCompra || ""),
        buscar: "documentoCompra",
        ellipsis: true,
      },
      {
        title: "Responsable",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
        sorter: (a, b) => (a.nombreUsuario || "").localeCompare(b.nombreUsuario || ""),
        buscar: "nombreUsuario",
        ellipsis: true,
      },
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteEntradasSalidas"
          onFinish={this.consultarReporteEntradasSalidas.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Entradas y Salidas de Inventario"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  {this.state.todasInventario.filter((value) => value.esMovimientoApartado).length > 0 && (
                    <ButtonItem
                      type={this.state.mostrarApartados ? "primary" : "default"}
                      onClick={() => this.setState({ mostrarApartados: !this.state.mostrarApartados })}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      {this.state.mostrarApartados
                        ? "Ocultar apartados"
                        : `Mostrar apartados (${this.state.todasInventario.filter((value) => value.esMovimientoApartado).length})`}
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                  <FormItem initialValue={[moment().subtract(1, "month"), moment()]} name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Insumos">
                  <FormItem name="insumos" margin noStyle>
                    <SelectInsumosItem
                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      mode="multiple"
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="inventariables"
                    />
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <div style={{ height: 10 }}></div>
            <TableItem
              rowKey={(value) => value.insumoId.toString() + Math.random()}
              columns={columns}
              dataSource={this.movimientosVisibles()}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    empresa: state.empresa.nombre,
  };
};

export default connect(mapStateToProps)(ReporteEntradasSalidas);
